<template>
  <div class="page-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Pengusulan</h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="/admin/pengusulan">Pengusulan</a></li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div><h4 class="card-title">Manajemen Pengusulan</h4></div>
                <div><a class="btn btn-success" href="/admin/pengusulan/pengusulan">Buat Usulan Pengajuan</a></div>
              </div>
              <hr />
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th>Pengusul</th>
                      <th>Pengusulan / Pelaksanaan</th>
                      <th>Biaya / Durasi</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td scope="row" class="text-center" rowspan="2" style="vertical-align: middle">1</td>
                      <td scope="row">Administrator</td>
                      <td scope="row">
                        <div class="d-inline-block"><span>2021</span> / <span>2022</span></div>
                        <div class="d-inline-block px-1"><span class="badge mx-1 bg-primary">Kegiatan</span><span class="badge bg-info">Semua Komoditi</span></div>
                      </td>
                      <td scope="row">Rp. <span>18610000.00</span> / <span>3</span> Bulan</td>
                      <td scope="row" class="text-center"><a class="p-0 btn btn-sm btn-link">Lihat</a> | <a class="p-0 btn btn-sm btn-link">Edit</a> | <a class="p-0 btn btn-sm btn-link">Hapus</a></td>
                    </tr>
                    <tr>
                      <td scope="row" class="bg-light" colspan="2" style="white-space: normal; border-left: 0.25em solid rgb(0, 170, 255)">Uji Unjukkerja Kontroler ONOS dan Floodlinght Sebagai Dasar Pemilihan Kontroler</td>
                      <td scope="row"><a class="badge bg-warning me-2" href="/admin/pengisian/2875c5c9-0831-4542-9beb-04febc35b96d">Belum Melengkapi Proposal!</a></td>
                      <td scope="row" class="text-center text-muted">
                        <small><i>9/14/2022, 3:47:54 PM</i></small>
                      </td>
                    </tr>
                    <!---->
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layout from '@/layout/Index'
export default {
  layout,
}
</script>
